import { Home, Sprout, Pickaxe, Package, DoorOpen, Flag } from "lucide-react";

export const CUSTOM_TYPES = {
  base: { label: "Base", color: "#00CCFF", icon: Home },
  farm: { label: "Spot de farm", color: "#22C55E", icon: Sprout },
  mine: { label: "Mine", color: "#A8A29E", icon: Pickaxe },
  chest: { label: "Coffre", color: "#EAB308", icon: Package },
  dungeon: { label: "Donjon", color: "#8B5CF6", icon: DoorOpen },
  note: { label: "Note", color: "#F59E0B", icon: Flag },
};
